import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgChat = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 3.25A2.75 2.75 0 003.25 6v8.753A2.75 2.75 0 006 17.503h.907V20a.75.75 0 001.204.597l4.066-3.095H18a2.75 2.75 0 002.75-2.75V6A2.75 2.75 0 0018 3.25H6zM4.75 6c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v3.132a1 1 0 100 1.735v3.885c0 .69-.56 1.25-1.25 1.25h-6.076a.75.75 0 00-.454.154l-3.063 2.33v-1.733a.75.75 0 00-.75-.75H6c-.69 0-1.25-.56-1.25-1.25V6zm10.126 4a1 1 0 11-2 0 1 1 0 012 0zM9 11a1 1 0 100-2 1 1 0 000 2z"
      clipRule="evenodd"
    />
  </svg>
));
SvgChat.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgChat;
